import { PrivilegeChecker } from 'omni-common-ui';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import UnlockHomework from './component';
import ViewNav from 'components/ViewNav';
import Privileges from 'domain/Privileges';

export const isUnlockHomeworkEnabled = (state, groupId) =>
    TabSwitcher.isTabEnabled(state, groupId, TabCodes.UnlockHomework);

const actionButtons = (getState) => ({
  Unlock: {
    isPrimary: true,
    route: './unlock',
    visibleWhen: () =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.View),
    disableWhen: ({ params }) => params.mode !== 'edit-unlock',
  },
});

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'view-nav': {
        component: ViewNav,
        props: {
          hideExpandable: true,
        },
      },
    },
  },
  path: 'unlock-homework(/:mode)',
  canAccess: ({ params: { groupId } }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.View) &&
        isUnlockHomeworkEnabled(getState(), groupId),
  component: UnlockHomework,
  actionButtons: {
    default: actionButtons(),
    'edit-unlock': actionButtons(),
  },
});



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/UnlockHomework/routes.js